import { Button, Form, Row, Col, Spinner } from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./ForgotPassword.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";
import KeyIcon from '@mui/icons-material/Key';

const ForgotPassword = () => {
  const { handleLogin, sendEmailResetPassword } = useContext(AuthContext);
  const { getUsersById } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  const [email, setEmail] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await sendEmailResetPassword(email);
    setLoading(false);
  };

  const handleInputChange = (valueAtt: any, name: string) => {
    setEmail(valueAtt);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div style={{ position: "absolute", top: "30px", right: "10px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/auth/login";
          }}
          className="button-create-user"
          type="button"
          disabled={loading}
        >
          <Person2OutlinedIcon />
          Login
        </Button>
      </div>
      <Row className="justify-content-center forgot-container">
        <Col
          lg="10"
          md="7"
          className="d-flex forgot-content"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
            marginTop: "82px",
          }}
        >
          <img
            className="forgot-logo"
            alt="Logo"
            src={require("../../assets/img/brand/Simbolo_Negativa_sf.png")}
          />

          <div className="d-flex forgot-slogan" style={{ flexDirection: "column", gap: "4px" }}>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "5.76px",
                color: "#43474F",
                opacity: 1,
                fontSize: "24px",
              }}
            >
              Vamos ajudá-lo a redefinir sua senha.{" "}
            </span>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "2.24px",
                color: "#43474F",
                opacity: 0.7,
                fontSize: "11px",
              }}
            >
              Digite seu e-mail no campo abaixo. Você receberá um link para
              redefinir sua senha.{" "}
            </span>
          </div>

          <div className="forgot-form-wrapper">
            <Form
              role="form"
              className="forgot-form"
            >
              <InputEmailLogin
                name="email"
                value={email}
                handleChange={handleInputChange}
                label={"E-mail"}
                onKeyDown={handleKeyDown}
              />
            </Form>
            <div className="text-center d-flex justify-content-center">
              <Button
                onClick={handleLoginClick}
                className="my-4 button-login"
                type="button"
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <KeyIcon />
                )}{" "}
                Enviar E-mail
              </Button>
            </div>
          </div>

          <div
            className="forgot-register-link"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/auth/register";
            }}
          >
            <span className="forgot-register-text">Ainda não tem conta? </span>
            <span className="forgot-register-cta">Crie uma gratuitamente!</span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword;
